import { Checkbox } from "@alm/flow-ds/components";
import BusinessLogicContext, {
	BusinessLogicContextProps,
} from "contexts/BusinessLogicContext";
import React, { useCallback, useContext } from "react";

interface Props {
	nextProp: string;
	logicIndex?: number;
	hint: string;
	label: string;
}

export default ({ nextProp, logicIndex, hint, label }: Props) => {
	const { action, handleUpdateStore, elementIndex, value } = useContext(
		BusinessLogicContext
	) as BusinessLogicContextProps;

	const handleChange = useCallback(
		e => {
			handleUpdateStore({
				...value,
				allData: e.target.checked,
			});
		},
		[handleUpdateStore, value]
	);

	return (
		<Checkbox
			id={`${action}-${elementIndex}-${nextProp}-${logicIndex}-allData`}
			value={!!value as unknown as string}
			checked={value.allData}
			label={label}
			onChange={handleChange}
			className="align-col"
			hint={hint}
			disabled={value.dataMap.length > 0}
		/>
	);
};
